import { render, staticRenderFns } from "./EquipmentAgeQuestion.vue?vue&type=template&id=cd5d0c1c&scoped=true"
import script from "./EquipmentAgeQuestion.vue?vue&type=script&lang=ts"
export * from "./EquipmentAgeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5d0c1c",
  null
  
)

export default component.exports